// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__37Fye","footer":"Form_footer__1yvT4"};